<button
  class="timeline-layer-select"
  [class.timeline-layer-select--active]="selected"
  (click)="onClick()"
  title="Select the layer"
  i18n-title
>
  <ng-container *ngIf="selected" i18n>Selected</ng-container>
  <ng-container *ngIf="selected === false" i18n>Select</ng-container>
</button>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer/timeline-layer-select/timeline-layer-select.component.html